(function () {
  'use strict';

  angular
    .module('uos')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('root.uos', {
        url: '/uos',
        views: {
          'content@': {
            templateUrl: 'uos/uos.tpl.html',
            controller: 'UosCtrl',
            controllerAs: 'uos'
          }
        },
        data: {
          titulo: 'core-permissoes.organizacao.uos.titulo',
          tituloDescricao: 'core-permissoes.organizacao.uos.tituloDescricaoConsulta'
        }
      })
      .state('root.uoCadastro', {
        url: '/uos/cadastro/:uoId/:uoPai',
        views: {
          'content@': {
            templateUrl: 'uos/cadastrar-uo.tpl.html',
            controller: 'CadastrarUoCtrl',
            controllerAs: 'cadastrarUoCtrl'
          }
        },
        data: {
          titulo: 'core-permissoes.organizacao.uos.titulo',
          tituloDescricao: 'core-permissoes.organizacao.uos.tituloDescricaoCadastro',
          role: 'UO_EDITAR'
        }
      })
      .state('root.parceira', {
        url: '/uos/parceira/:uoId',
        views: {
          'content@': {
            templateUrl: 'uos/parceira.tpl.html',
            controller: 'ParceiraCtrl',
            controllerAs: 'parceiraCtrl'
          }
        },
        data: {
          titulo: 'core-permissoes.organizacao.uos.parceiraTitulo',
          role: 'ADMIN_VELTEC'
        }
      });
  }
}());
